import { ReduxSimpleActionInterface } from '@ecommerce/nest-ssr/dist/common';
import OfferInterface from 'interfaces/offer.interface';
import hasActiveFilter from '../helpers/has-active-filter';
import { offersSort } from 'helpers/offers-sort';
import replaceState from 'modules/product/helpers/replace-state';

export enum OffersActions {
    BestOffer = 'OFFERS_SORT_SCORE',
    PriceAsc = 'OFFERS_SORT_PRICE_ASC',
    PriceDesc = 'OFFERS_SORT_PRICE_DESC',
    ShopScore = 'OFFERS_SORT_SHOP_SCORE',
    Filter = 'OFFERS_FILTER',
    SelectFilters = 'SELECT_FILTERS'
}

export enum SortType {
    BestOffer = 'score',
    PriceDesc = 'price-desc',
    PriceAsc = 'price-asc',
    ShopScore = 'shop-score'
}

export interface OffersState {
    prepared?: OfferInterface[];
    count?: number;
    activeFilters?: string[];
    selectedFilters?: string[];
    activeSort: SortType;
}

const updateWindowHistory = (replaceStatus: boolean, filters: string[] = [], sort: SortType): void => {
    if (replaceStatus) {
        replaceState(filters, sort);
    }
};

export const offers = [
    (
        state: OffersState,
        action: ReduxSimpleActionInterface<OffersActions.BestOffer, { payload: { items: OfferInterface[]; activeSort: SortType; replaceState: boolean; }; }> |
        ReduxSimpleActionInterface<OffersActions.ShopScore, { payload: { items: OfferInterface[]; activeSort: SortType; replaceState: boolean; }; }> |
        ReduxSimpleActionInterface<OffersActions.PriceDesc, { payload: { items: OfferInterface[]; activeSort: SortType; replaceState: boolean; }; }> |
        ReduxSimpleActionInterface<OffersActions.PriceAsc, { payload: { items: OfferInterface[]; activeSort: SortType; replaceState: boolean; }; }> |
        ReduxSimpleActionInterface<OffersActions.Filter, { payload: { items: OfferInterface[]; activeFilters: string[]; replaceState: boolean; }; }> |
        ReduxSimpleActionInterface<OffersActions.SelectFilters, { payload: { selectedFilters: string[]; }; }>
    ): OffersState => {
        switch (action.type) {
            case OffersActions.BestOffer:
                updateWindowHistory(action.payload.replaceState, state.activeFilters, action.payload.activeSort);

                return {
                    ...state,
                    prepared: [...action.payload.items]
                        .filter(offer => hasActiveFilter(state.activeFilters, offer))
                        .sort(offersSort(SortType.BestOffer)),
                    activeSort: SortType.BestOffer
                };
            case OffersActions.ShopScore:
                updateWindowHistory(action.payload.replaceState, state.activeFilters, action.payload.activeSort);

                return {
                    ...state,
                    prepared: [...action.payload.items]
                        .filter(offer => hasActiveFilter(state.activeFilters, offer))
                        .sort(offersSort(SortType.ShopScore))
                        .sort((prev, next) => Number(prev.dealer.outOfLimit) - Number(next.dealer.outOfLimit)),
                    activeSort: SortType.ShopScore
                };
            case OffersActions.PriceAsc:
                updateWindowHistory(action.payload.replaceState, state.activeFilters, action.payload.activeSort);

                return {
                    ...state,
                    prepared: [...action.payload.items]
                        .filter(offer => hasActiveFilter(state.activeFilters, offer))
                        .sort(offersSort(SortType.PriceAsc)),
                    activeSort: SortType.PriceAsc
                };
            case OffersActions.PriceDesc:
                updateWindowHistory(action.payload.replaceState, state.activeFilters, action.payload.activeSort);

                return {
                    ...state,
                    prepared: [...action.payload.items]
                        .filter(offer => hasActiveFilter(state.activeFilters, offer))
                        .sort(offersSort(SortType.PriceDesc)),
                    activeSort: SortType.PriceDesc
                };
            case OffersActions.Filter:
                updateWindowHistory(action.payload.replaceState, action.payload.activeFilters, state.activeSort);

                return {
                    ...state,
                    prepared: [...action.payload.items]
                        .filter(offer => hasActiveFilter(action.payload.activeFilters, offer))
                        .sort(offersSort(state.activeSort))
                        .sort((prev, next) => Number(prev.dealer.outOfLimit) - Number(next.dealer.outOfLimit)),
                    activeFilters: action.payload.activeFilters
                };
            case OffersActions.SelectFilters:
                return {
                    ...state,
                    selectedFilters: action.payload.selectedFilters
                };
            default:
                return state;
        }
    }
];
